import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import FlashMessage from "../FlashMessage";
import printNewQuoteInvoice from "./printNewQuoteInvoice";
import { printAllAtrInvoices } from "./generateSummaryPDF_atr";
import config from "../common/Config";
import { toast } from "sonner";
import { fetchPlaceOrder } from "../../data/epos";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import { format } from "date-fns";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Skeleton,
  Link as MuiLink,
  TextField,
  Chip,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  useMediaQuery,
  InputAdornment,
  Grid2,
  Tabs,
  Tab,
  Tooltip,
} from "@mui/material";
import { Iconify } from "src/components/iconify";
import StandaloneManageColumnsModal from "../tableComponents/manageColumns/StandaloneManageColumnsModal";
import "../common/commonStyles.css";
import { encryptPayload, normalizeEncryptedApiResponse } from "../../utils/customerCrypto";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../../utils/companySettingsCache";
import { resolveQuickBooksEnabled } from "../../utils/quickBooksTenant";

const QUICKBOOKS_MAX_ACCEPT_ORDERS = 3;

const baseColumns = [
  { id: "date", label: "Order Date", numeric: false, width: 90 },
  { id: "reference_no", label: "Order Id", numeric: false, width: 90 },
  { id: "customer", label: "Customers (A/C No)", numeric: false, width: 200 },
  { id: "postal_code", label: "Post Code", numeric: false, width: 90 },
  { id: "route_number", label: "Route", numeric: false, width: 70 },
  { id: "grand_total", label: "Order Amt", numeric: true, width: 90 },
  { id: "profit", label: "Profit(%)", numeric: true, width: 80 },
  { id: "prev_due", label: "C.Bal", numeric: true, width: 80 },
  { id: "amtDue", label: "Amt.Due", numeric: true, width: 80 },
  { id: "name", label: "Order By", numeric: false, width: 80 },
  { id: "sale_status", label: "Status", numeric: false, width: 80 },
  { id: "action", label: "Action", numeric: false, width: 70 },
];

const parseNumeric = (value) => {
  const numeric = parseFloat(String(value ?? "0").replace(/,/g, ""));
  return Number.isFinite(numeric) ? numeric : 0;
};

const isCollectShopOrder = (row) => {
  const flag =
    row?.is_collect ??
    row?.come_and_collect ??
    row?.collect_shop ??
    row?.is_collect_shop ??
    row?.collect_flag ??
    row?.come_collect ??
    0;
  return flag === 1 || flag === "1" || flag === true || flag === "Y" || flag === "y";
};

const NewRSales = () => {
  const [dates, setDates] = useState([null, null]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [actionAnchorEl, setActionAnchorEl] = useState(null);
  const [actionRow, setActionRow] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectData, setRejectData] = useState(null);
  const [rejectComment, setRejectComment] = useState("");
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [holdReason, setHoldReason] = useState("");
  const [holdOrderId, setHoldOrderId] = useState("");
  const [showHoldReasonModal, setShowHoldReasonModal] = useState(false);
  const [holdReasonText, setHoldReasonText] = useState("");
  const [showAmtDueModal, setShowAmtDueModal] = useState(false);
  const [amtDueLedgerData, setAmtDueLedgerData] = useState([]);
  const [amtDueCustomer, setAmtDueCustomer] = useState("");
  const [amtDueLoading, setAmtDueLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState(null);
  const [showDeliveryDateModal, setShowDeliveryDateModal] = useState(false);
  const [deliveryDateRow, setDeliveryDateRow] = useState(null);
  const [deliveryDateValue, setDeliveryDateValue] = useState("");
  const [deliveryDateSaving, setDeliveryDateSaving] = useState(false);
  const [batchPrinting, setBatchPrinting] = useState(false);
  const [batchPrintProgress, setBatchPrintProgress] = useState({
    current: 0,
    total: 0,
  });
  const batchPrintAbortRef = useRef(false);
  const [quickBooksOn, setQuickBooksOn] = useState(false);
  const [listTab, setListTab] = useState("new");
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem("token");
  const roleID = localStorage.getItem("roleID");
  const userId = localStorage.getItem("userId");
  const isAtrPrefix = accessToken === "atr";
  const isAcceptedTab = isAtrPrefix && listTab === "accepted";
  const columns = useMemo(
    () =>
      baseColumns.map((column) =>
        column.id === "route_number" && isAtrPrefix
          ? { id: "delivery_date", label: "Delivery Date", numeric: false, width: 110 }
          : column
      ),
    [isAtrPrefix]
  );
  const isCompactTable = useMediaQuery("(max-width:900px)");
  const [columnVisibility, setColumnVisibility] = useState(() => {
    try {
      const saved = localStorage.getItem("newRSalesColumnVisibility");
      if (saved) {
        const parsed = JSON.parse(saved);
        const visibility = {};
        baseColumns.forEach((_, idx) => {
          visibility[idx] = parsed[idx] !== false;
        });
        return visibility;
      }
    } catch (error) {
      console.error("Error loading column visibility:", error);
    }
    const visibility = {};
    baseColumns.forEach((_, idx) => {
      visibility[idx] = true;
    });
    return visibility;
  });
  const [hoveredHeader, setHoveredHeader] = useState(null);
  const [isManageColumnsOpen, setIsManageColumnsOpen] = useState(false);
  const manageColumnsConfig = useMemo(
    () => columns.map((column) => ({ header: column.label })),
    [columns],
  );
  const visibleColumns = useMemo(
    () =>
      columns
        .map((column, index) => ({ column, index }))
        .filter(({ index }) => columnVisibility[index] !== false),
    [columnVisibility, columns],
  );

  useEffect(() => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
    }
  }, [accessToken]);

  useEffect(() => {
    let cancelled = false;
    resolveQuickBooksEnabled().then((enabled) => {
      if (!cancelled) {
        setQuickBooksOn(!!enabled);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleCloseMessage = () => {
    setFlashMessage(null);
  };

  const fetchData = () => {
    if (!accessToken) {
      return;
    }
    setLoading(true);
    (async () => {
      const settings = await getCompanySettings();
      const useEncrypt = resolveCustomerApiEncrypt(settings);
      let reqConfig = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      let payload;
      if (useEncrypt) {
        const plain = {
          draw: String(page + 1),
          start: String(page * rowsPerPage),
          length: String(rowsPerPage),
          searchValue: searchTerm,
          search: { value: searchTerm, regex: "false" },
          searchByFromdate: startDate,
          searchByTodate: endDate,
          channels: "",
        };
        if (isAcceptedTab) {
          plain.Accept = "Y";
        }
        const ep = encryptPayload(plain);
        if (!ep) {
          setLoading(false);
          toast.error("Failed to load sales.");
          setData([]);
          setTotalRows(0);
          return;
        }
        const fd = new FormData();
        fd.append("encrypted_payload", ep);
        payload = fd;
      } else {
        const params = new URLSearchParams();
        params.append("draw", String(page + 1));
        params.append("start", String(page * rowsPerPage));
        params.append("length", String(rowsPerPage));
        params.append("searchValue", searchTerm);
        params.append("search[value]", searchTerm);
        params.append("search[regex]", "false");
        params.append("searchByFromdate", startDate);
        params.append("searchByTodate", endDate);
        params.append("order[0][column]", "0");
        params.append("order[0][dir]", "desc");
        if (isAcceptedTab) {
          params.append("Accept", "Y");
        }
        columns.forEach((column, index) => {
          params.append(`columns[${index}][data]`, column.id);
          params.append(`columns[${index}][name]`, "");
          params.append(`columns[${index}][searchable]`, "false");
          params.append(`columns[${index}][orderable]`, "false");
          params.append(`columns[${index}][search][value]`, "");
          params.append(`columns[${index}][search][regex]`, "false");
        });
        payload = params;
        reqConfig.headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
      axios
        .post(`${config.API_URL}/sales/saleslist_test`, payload, reqConfig)
        .then((response) => {
          const json =
            normalizeEncryptedApiResponse(response.data, useEncrypt) ||
            response.data ||
            {};
          const rows = Array.isArray(json.data) ? json.data : [];
          setData(rows);
          const filteredCount = Number(json.recordsFiltered);
          const totalCount = Number.isFinite(filteredCount)
            ? filteredCount
            : Number(json.recordsTotal) || rows.length;
          setTotalRows(totalCount);
          setSelectedRows([]);
        })
        .catch((err) => {
          const status = err.response?.status;
          const message =
            err.response?.data?.message || err.message || "Failed to load sales.";
          toast.error(status ? `Error ${status}: ${message}` : message);
          setData([]);
          setTotalRows(0);
        })
        .finally(() => {
          setLoading(false);
        });
    })();
  };

  useEffect(() => {
    fetchData();
  }, [
    accessToken,
    page,
    rowsPerPage,
    searchTerm,
    startDate,
    endDate,
    refreshKey,
    listTab,
    isAcceptedTab,
  ]);

  const handleDateChange = (value) => {
    const range = Array.isArray(value) ? value : [null, null];
    setDates(range);
    const start = range[0] ? format(range[0], "yyyy-MM-dd") : "";
    const end = range[1] ? format(range[1], "yyyy-MM-dd") : "";
    setStartDate(start);
    setEndDate(end);
    setPage(0);
    setRefreshKey((key) => key + 1);
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setPage(0);
      setRefreshKey((key) => key + 1);
    }
  };

  const handleSubmit = () => {
    setPage(0);
    setRefreshKey((key) => key + 1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClearFilter = () => {
    setDates([null, null]);
    setStartDate("");
    setEndDate("");
    setSearchTerm("");
    setPage(0);
    setRefreshKey((key) => key + 1);
  };

  const handleColumnVisibilityChange = (visibility) => {
    setColumnVisibility(visibility);
    try {
      localStorage.setItem(
        "newRSalesColumnVisibility",
        JSON.stringify(visibility),
      );
    } catch (error) {
      console.error("Error saving column visibility:", error);
    }
  };

  const handleSelectAllRows = (event) => {
    if (event.target.checked) {
      const selectableIds = data
        .filter((row) => row.sale_status !== "Hold")
        .map((row) => String(row.ids));
      setSelectedRows(selectableIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (row) => {
    const id = String(row.ids);
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((item) => item !== id));
    } else if (row.sale_status !== "Hold") {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const isRowSelected = (row) => selectedRows.includes(String(row.ids));

  const handleActionMenuOpen = (event, row) => {
    setActionAnchorEl(event.currentTarget);
    setActionRow(row);
  };

  const handleActionMenuClose = () => {
    setActionAnchorEl(null);
    setActionRow(null);
  };

  const handleRejectClick = (row) => {
    setRejectData(row);
    setRejectComment("");
    setShowRejectModal(true);
    handleActionMenuClose();
  };

  const handleRejectSubmit = () => {
    if (!rejectComment) {
      toast.error("Please enter reason for reject.");
      return;
    }
    const formData = new FormData();
    formData.append("status", "Reject");
    formData.append("reason_note", rejectComment);
    formData.append("new-sales", "Yes");
    formData.append("id", rejectData.ids);
    axios
      .post(`${config.API_URL}/ws-update-status`, formData, {
        headers: { authorization: `Bearer ${token}` },
      })
      .then(() => {
        setShowRejectModal(false);
        setRejectComment("");
        setFlashMessage({
          message: "Order rejected successfully",
          type: "success",
        });
        setRefreshKey((key) => key + 1);
      })
      .catch(() => {
        setFlashMessage({ message: "Error rejecting order", type: "error" });
      });
  };

  const handleHoldClick = (row) => {
    setHoldOrderId(row.ids);
    setHoldReason("");
    setShowHoldModal(true);
    handleActionMenuClose();
  };

  const handleHoldSubmit = () => {
    if (!holdReason) {
      toast.error("Please enter reason for hold.");
      return;
    }
    const formData = new FormData();
    formData.append("status", "Hold");
    formData.append("reason_note", holdReason);
    formData.append("id", holdOrderId);
    formData.append("new-sales", "No");
    axios
      .post(`${config.API_URL}/ws-update-status`, formData, {
        headers: { authorization: `Bearer ${token}` },
      })
      .then(() => {
        setShowHoldModal(false);
        setFlashMessage({
          message: "Order Hold successfully",
          type: "success",
        });
        setRefreshKey((key) => key + 1);
      })
      .catch(() => {
        setFlashMessage({ message: "Error holding order", type: "error" });
      });
  };

  const handleConvertToNewOrder = (id) => {
    setConfirmDialogData({
      title: "Are you sure?",
      message: "Do you want to transfer this order to new sales?",
      onConfirm: () => {
        const formData = new FormData();
        formData.append("status", "New");
        formData.append("id", id);
        formData.append("reason_note", "");
        formData.append("user_id", userId);
        formData.append("new-sales", "No");
        axios
          .post(`${config.API_URL}/ws-update-status`, formData, {
            headers: {
              authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            setFlashMessage({
              message: "Order has been transferred",
              type: "success",
            });
            setRefreshKey((key) => key + 1);
          })
          .catch(() => {
            setFlashMessage({ message: "Something went wrong", type: "error" });
          });
        setShowConfirmDialog(false);
        setConfirmDialogData(null);
      },
    });
    setShowConfirmDialog(true);
    handleActionMenuClose();
  };

  const handleAcceptOrders = async () => {
    if (!selectedRows.length) {
      toast.error("Please select an order to accept.");
      return;
    }
    if (quickBooksOn && selectedRows.length > QUICKBOOKS_MAX_ACCEPT_ORDERS) {
      toast.error(
        `Maximum ${QUICKBOOKS_MAX_ACCEPT_ORDERS} orders can be accepted when QuickBooks is enabled.`
      );
      return;
    }
    const settings = await getCompanySettings();
    const useEncrypt = resolveCustomerApiEncrypt(settings);
    let body;
    const headers = { authorization: `Bearer ${token}` };
    if (useEncrypt) {
      const ep = encryptPayload({ val: selectedRows });
      if (!ep) {
        toast.error("Error Accepting Order");
        return;
      }
      const fd = new FormData();
      fd.append("encrypted_payload", ep);
      body = fd;
    } else {
      const formData = new FormData();
      selectedRows.forEach((value) => formData.append("val[]", value));
      body = formData;
    }
    axios
      .post(`${config.API_URL}/sales/add_orders_front_sheet`, body, { headers })
      .then((res) => {
        normalizeEncryptedApiResponse(res.data, useEncrypt);
        toast.success("Accept Order successfully");
        setRefreshKey((key) => key + 1);
      })
      .catch(() => {
        toast.error("Error Accepting Order");
      });
  };

  const handleAmtDueClick = (row) => {
    setAmtDueCustomer(row.customer);
    setShowAmtDueModal(true);
    setAmtDueLedgerData([]);
    setAmtDueLoading(true);
    const formData = new FormData();
    formData.append("customerId", row.customer_id);
    formData.append("platform", "web");
    formData.append("showDueInvoicesOnly", "Y");
    formData.append("authorization", `Bearer ${token}`);
    axios
      .post(`${config.API_URL}/ws-get-previous-invoice-list`, formData, {
        headers: { authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const ledger = response.data?.invoice_details;
        setAmtDueLedgerData(Array.isArray(ledger) ? ledger : []);
      })
      .catch(() => {
        setAmtDueLedgerData([]);
      })
      .finally(() => {
        setAmtDueLoading(false);
      });
  };

  const handlePrintInvoice = (id) => {
    // Action-menu Print Invoice: open invoice page (do not auto-print).
    // Direct print is only via multi-select → Print All Invoices.
    window.open(
      `${config.BASE_URL}/sales/invoice/${id}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handlePrintAllInvoices = async () => {
    if (accessToken !== "atr") {
      toast.error("Print all invoices is only available for ATR");
      return;
    }
    if (!selectedRows.length) {
      toast.error("Please select at least one invoice");
      return;
    }
    if (batchPrinting) return;

    const ids = selectedRows.map(String);
    // Open under user gesture so the print dialog is less likely to be blocked
    let printWin = window.open("about:blank", "batchPrintInvoiceWindow");
    if (!printWin) {
      toast.error("Please allow popups to print invoices");
      return;
    }

    batchPrintAbortRef.current = false;
    setBatchPrinting(true);
    setBatchPrintProgress({ current: 0, total: ids.length });
    toast.message("Preparing invoices… then select printer and print");

    try {
      const result = await printAllAtrInvoices(ids, {
        targetWindow: printWin,
        onProgress: ({ current, total }) => {
          setBatchPrintProgress({ current, total });
        },
      });

      if (result?.printWin) {
        printWin = result.printWin;
      }

      if (result?.status === "blocked") {
        toast.error("Print window was blocked. Allow popups and try again.");
        return;
      }
      if (result?.status === "error" || !result?.count) {
        toast.error("Could not prepare invoices for print");
        return;
      }
      if (!batchPrintAbortRef.current) {
        toast.success(`Sent ${result.count} invoice(s) to printer`);
      }
    } finally {
      setBatchPrinting(false);
      setBatchPrintProgress({ current: 0, total: 0 });
    }
  };

  const handlePrintQuote = (id) => {
    printNewQuoteInvoice(id);
  };

  const handlePrintDeliveryNote = (id) => {
    window.open(
      `${config.BASE_URL}/invoice/rhp_delivery_note.html?orderId=${id}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handlePrintDrinkSheet = (id) => {
    window.open(
      `${config.BASE_URL}/invoice/rhp_drink_sheet.html?orderId=${id}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const toInputDate = (value) => {
    if (!value) return "";
    const raw = String(value).trim();
    if (
      !raw ||
      raw === "0000-00-00" ||
      raw === "00-00-0000" ||
      raw === "0000-00-00 00:00:00"
    ) {
      return "";
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    const parts = raw.split(/[\/\-]/);
    if (parts.length === 3) {
      // d-m-Y or d/m/Y
      if (parts[2].length === 4) {
        const [d, m, y] = parts;
        return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
      }
    }
    const ts = Date.parse(raw);
    if (!Number.isNaN(ts)) {
      return format(new Date(ts), "yyyy-MM-dd");
    }
    return "";
  };

  const formatDisplayDate = (value) => {
    const input = toInputDate(value);
    if (!input) return "-";
    try {
      return format(new Date(input), "dd-MM-yyyy");
    } catch {
      return "-";
    }
  };

  const isSundayDate = (yyyyMmDd) => {
    if (!yyyyMmDd) return false;
    const [y, m, d] = String(yyyyMmDd).split("-").map(Number);
    if (!y || !m || !d) return false;
    return new Date(y, m - 1, d).getDay() === 0;
  };

  const handleChangeDeliveryDateClick = (row) => {
    handleActionMenuClose();
    const currentDeliveryDate =
      row?.delivery_date || row?.deliverydate || "";
    setDeliveryDateRow(row);
    setDeliveryDateValue(toInputDate(currentDeliveryDate));
    setShowDeliveryDateModal(true);
  };

  const handleSaveDeliveryDate = async () => {
    const orderId = deliveryDateRow?.ids ?? deliveryDateRow?.id;
    if (!orderId) {
      toast.error("Order not found.");
      return;
    }
    if (!deliveryDateValue) {
      toast.error("Please select a delivery date.");
      return;
    }
    if (isSundayDate(deliveryDateValue)) {
      toast.error(
        "Office is closed on Sunday. Please select another delivery date."
      );
      return;
    }

    setDeliveryDateSaving(true);
    try {
      const formData = new FormData();
      formData.append("id", orderId);
      formData.append("delivery_date", deliveryDateValue);
      if (isAtrPrefix) {
        formData.append("invoice_date", deliveryDateValue);
      }
      const response = await axios.post(
        `${config.API_URL}/ws-update-delivery-date`,
        formData,
        { headers: { authorization: `Bearer ${token || accessToken}` } },
      );
      if (response.data?.success) {
        toast.success(response.data.message || "Delivery date updated.");
        setShowDeliveryDateModal(false);
        setDeliveryDateRow(null);
        setDeliveryDateValue("");
        setRefreshKey((key) => key + 1);
      } else {
        toast.error(response.data?.message || "Failed to update delivery date.");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || "Failed to update delivery date.",
      );
    } finally {
      setDeliveryDateSaving(false);
    }
  };

  const handleReferenceOpen = async (event, row, url) => {
    event.preventDefault();
  
    const orderId = row?.ids ?? row?.id ?? row?.order_id;
    if (!orderId) return;
  
    const authToken = token || accessToken;
  
    try {
      const data = await fetchPlaceOrder(orderId);

      const apiMessage = String(data?.message || "").trim();
  
      if (apiMessage) {
        if (
          /already\s*open|open(?:ed)?\s*by|another user/i.test(apiMessage)
        ) {
          toast.error(apiMessage);
          return;
        }
      }

      const order =
        (Array.isArray(data?.details?.orderDetails) &&
          data.details.orderDetails[0]) ||
        (Array.isArray(data?.details?.order_details) &&
          data.details.order_details[0]) ||
        null;
  
      const isOpen = Number(order?.is_open ?? row?.is_open ?? 0) === 1;
  
      const openedId = String(order?.opened_id ?? row?.opened_id ?? "");
  
      const myId = String(userId ?? "");
  
      if (isOpen && (!myId || openedId !== myId)) {
        const who =
          order?.opened_by && String(order.opened_by).trim()
            ? String(order.opened_by).trim()
            : row?.opened_by && String(row.opened_by).trim()
            ? String(row.opened_by).trim()
            : "another user";
  
        toast.error(`This order is already open by ${who}`);
        return;
      }
  
      window.location.href = url;
    } catch (error) {
      console.error(error);
      window.location.href = url;
    }
  };

  const amtDueTotal = useMemo(() => {
    return amtDueLedgerData
      .reduce((sum, item) => sum + parseNumeric(item.grand_total), 0)
      .toFixed(2);
  }, [amtDueLedgerData]);

  const renderCellContent = (columnId, row) => {
    if (columnId === "reference_no") {
      const isHold = row.sale_status === "Hold";
      const staffNote = String(row.staff_note || row.staffNote || row.note || "").trim();
      const noteIconColor = isHold ? "#f14240" : "#0456f1";

      const orderIdNode = (() => {
        if (isAcceptedTab) {
          return (
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "0.7rem",
                color: "inherit",
                flexShrink: 0,
              }}
            >
              {row.reference_no}
            </Typography>
          );
        }
        const url =
          accessToken === "sdm"
            ? `${config.BASE_URL}/sales/edit_invoice_sdm/${row.ids}`
            : `${config.BASE_URL}/sales/edit/${row.ids}`;

        if (isHold) {
          return (
            <Typography
              sx={{
                fontWeight: 500,
                textDecoration: "underline !important",
                textDecorationColor: "currentColor",
                color: "#f14240",
                fontSize: "0.7rem",
                flexShrink: 0,
              }}
            >
              {row.reference_no}
            </Typography>
          );
        }

        return (
          <MuiLink
            href={url}
            onClick={(event) => handleReferenceOpen(event, row, url)}
            sx={{
              color: "inherit",
              textDecoration: "underline !important",
              textDecorationColor: "currentColor",
              textUnderlineOffset: "2px",
              flexShrink: 0,
              "&:hover": {
                textDecoration: "underline !important",
                textDecorationColor: "currentColor",
                cursor: "pointer",
              },
            }}
          >
            {row.reference_no}
          </MuiLink>
        );
      })();

      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          {orderIdNode}
          {staffNote ? (
            <Tooltip
              title={staffNote}
              arrow
              placement="top"
              enterDelay={200}
              slotProps={{
                tooltip: {
                  sx: {
                    maxWidth: 320,
                    whiteSpace: "pre-wrap",
                    fontSize: "0.75rem",
                  },
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  cursor: "pointer",
                  flexShrink: 0,
                }}
              >
                <Iconify
                  icon="eva:info-fill"
                  width={14}
                  sx={{ color: noteIconColor }}
                />
              </Box>
            </Tooltip>
          ) : null}
        </Box>
      );
    }
    if (columnId === "sale_status") {
      const color = row.sale_status === "Hold" ? "warning" : "error";
      return (
        <Chip
          label={row.sale_status}
          color={color}
          variant="soft"
          size="small"
          sx={{ fontWeight: 500, fontSize: "0.7rem", px: 1 }}
        />
      );
    }
    if (columnId === "amtDue") {
      const isHold = row.sale_status === "Hold";
      return (
        <Typography
          onClick={() => handleAmtDueClick(row)}
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            color: isHold ? "#f14240" : "inherit",
            fontSize: "0.75rem",
            "&:hover": {
              color: isHold ? "#f14240" : "primary.main",
            },
          }}
        >
          {row.amtDue}
        </Typography>
      );
    }
    if (columnId === "delivery_date") {
      const value = formatDisplayDate(row.delivery_date || row.deliverydate || "");
      const isHold = row.sale_status === "Hold";
      const isCollectShop = isCollectShopOrder(row);
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          <Typography
            sx={{
              color: isHold ? "#f14240" : "inherit",
              fontSize: "0.75rem",
              flexShrink: 0,
            }}
          >
            {value}
          </Typography>
          {isCollectShop ? (
            <Chip
              label="Collect"
              size="small"
              color="info"
              variant="soft"
              sx={{
                height: 18,
                fontSize: "0.6rem",
                fontWeight: 600,
                flexShrink: 0,
                "& .MuiChip-label": { px: 0.75, py: 0 },
              }}
            />
          ) : null}
        </Box>
      );
    }
    if (columnId === "action") {
      if (roleID === "20") {
        return null;
      }
      return (
        <>
          <IconButton
            size="small"
            onClick={(event) => handleActionMenuOpen(event, row)}
          >
            {/* <MoreVertIcon fontSize="small" /> */}
            <Iconify icon="mdi:dots-vertical" />
          </IconButton>
        </>
      );
    }
    const value = row[columnId];
    if (row.sale_status === "Hold") {
      return (
        <Typography sx={{ color: "#f14240", fontSize: "0.75rem" }}>
          {value}
        </Typography>
      );
    }
    if (columns.find((column) => column.id === columnId)?.numeric) {
      return value;
    }
    return value ?? "";
  };

  const allSelectableIds = data
    .filter((row) => row.sale_status !== "Hold")
    .map((row) => String(row.ids));
  const selectAllTargetIds = allSelectableIds;
  const allSelected =
    selectAllTargetIds.length > 0 &&
    selectAllTargetIds.every((id) => selectedRows.includes(id)) &&
    selectedRows.length === selectAllTargetIds.length;
  const acceptOrderDisabled =
    !selectedRows.length ||
    (quickBooksOn && selectedRows.length > QUICKBOOKS_MAX_ACCEPT_ORDERS);

  const isTeleSales = roleID === "20";
  const isRHPOrHP = accessToken === "rhp" || accessToken === "hp";
  const showChangeDeliveryDate = isRHPOrHP || isAtrPrefix;

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        className="page-container"
        sx={{
          flex: 1,
          minHeight: 0,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          p: "4px !important",
        }}
      >
        <Paper
          className="paper-style"
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <Box sx={{ px: 1.5, py: 0.75, flexShrink: 0 }}>
            {isAtrPrefix && (
              <Tabs
                value={listTab}
                onChange={(event, newValue) => {
                  setListTab(newValue);
                  setPage(0);
                  setSelectedRows([]);
                  setRefreshKey((key) => key + 1);
                }}
                variant="scrollable"
                scrollButtons="auto"
                className="common-tabs"
                sx={{ mb: 1 }}
              >
                <Tab label="New Sales" value="new" />
                <Tab label="Accepted" value="accepted" />
              </Tabs>
            )}
            <Grid2
              container
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid2 size={{ xs: 12, md: 2 }}>
                <Box>
                  <Typography className="page-title">
                    {isAcceptedTab ? "Accepted Sales" : "New Sales"}
                  </Typography>
                </Box>
              </Grid2>
              <Grid2
                size={{ xs: 12, md: 10 }}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: { xs: "stretch", md: "flex-end" },
                  gap: 1,
                  rowGap: 1,
                }}
              >
                <TextField
                  className="input-border"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  onKeyDown={handleSearchKeyDown}
                  size="small"
                  placeholder="Search sales..."
                  variant="outlined"
                  sx={{
                    flex: { xs: "1 1 100%", md: "1 1 220px" },
                    minWidth: { xs: "100%", md: 180 },
                    maxWidth: { md: 320 },
                  }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Iconify
                            icon="eva:search-outline"
                            width={20}
                            height={20}
                            sx={{ color: "#212121" }}
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <Box
                  sx={{
                    width: { xs: "100%", md: 220 },
                    minWidth: { md: 200 },
                    flexShrink: 0,
                  }}
                >
                  <CommonDatePicker
                    value={dates}
                    onChange={handleDateChange}
                    className="date-picker input-border"
                  />
                </Box>
                <Button
                  variant="outlined"
                  className="button-variant-outlined"
                  startIcon={
                    <Iconify
                      icon="eva:refresh-outline"
                      width={18}
                      height={18}
                    />
                  }
                  onClick={handleClearFilter}
                  sx={{
                    width: { xs: "100%", md: "auto" },
                    flexShrink: 0,
                  }}
                >
                  Clear
                </Button>
                {!isTeleSales && !isAcceptedTab && (
                  <Button
                    variant="contained"
                    className="button-variant-contained"
                    onClick={handleAcceptOrders}
                    disabled={acceptOrderDisabled}
                    sx={{
                      width: { xs: "100%", md: "auto" },
                      fontWeight: 600,
                      px: 2,
                      boxShadow: "none",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "#F8991D",
                        color: "#fff",
                      },
                      "&:disabled": {
                        opacity: 0.48,
                      },
                    }}
                  >
                    Accept Order
                  </Button>
                )}
                {isAtrPrefix && selectedRows.length > 0 && (
                  <Button
                    variant="contained"
                    className="button-variant-contained"
                    onClick={handlePrintAllInvoices}
                    disabled={batchPrinting}
                    sx={{
                      width: { xs: "100%", md: "auto" },
                      fontWeight: 600,
                      px: 2,
                      boxShadow: "none",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: "#F8991D",
                        color: "#fff",
                      },
                      "&:disabled": {
                        opacity: 0.48,
                      },
                    }}
                  >
                    {batchPrinting
                      ? `Printing ${batchPrintProgress.current}/${batchPrintProgress.total}…`
                      : `Print All (${selectedRows.length})`}
                  </Button>
                )}
              </Grid2>
            </Grid2>
          </Box>

          {/* Table Section */}
          <TableContainer
            sx={{
              width: "100%",
              flex: 1,
              minHeight: 0,
              overflowX: "auto",
              overflowY: "auto",
              position: "relative",
              "&::-webkit-scrollbar": { height: "8px", width: "8px" },
              "&::-webkit-scrollbar-track": { backgroundColor: "#f5f7fa" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(145, 158, 171, 0.32)",
                borderRadius: "4px",
              },
            }}
          >
            {visibleColumns.length === 0 && (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1000,
                  textAlign: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  padding: 3,
                  borderRadius: 2,
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                  border: "1px solid rgba(145, 158, 171, 0.16)",
                  minWidth: 280,
                }}
              >
                <Iconify
                  icon="eva:eye-off-outline"
                  width={48}
                  height={48}
                  sx={{ color: "#637381", mb: 1.5 }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    mb: 1,
                    color: "#212b36",
                    fontSize: "1rem",
                    fontWeight: 600,
                  }}
                >
                  All Columns Hidden
                </Typography>
                <Typography
                  sx={{ fontSize: "0.875rem", color: "#637381", mb: 2 }}
                >
                  All table columns are currently hidden. Click below to manage
                  column visibility.
                </Typography>
                <Button
                  variant="contained"
                  className="button-variant-"
                  onClick={() => setIsManageColumnsOpen(true)}
                  startIcon={<Iconify icon="mdi:cog" width={18} height={18} />}
                >
                  Manage Columns
                </Button>
              </Box>
            )}
            <Table
              size="small"
              stickyHeader
              className="table-cell-border"
              sx={{
                "& .MuiTableCell-paddingCheckbox": {
                  width: 52,
                  minWidth: 52,
                  px: 0.6,
                  py: "4px !important",
                },
                opacity: visibleColumns.length === 0 ? 0.3 : 1,
                "& .MuiTableCell-head": {
                  backgroundColor: "#f4f6f8",
                  py: "6px !important",
                  paddingTop: "6px !important",
                  paddingBottom: "6px !important",
                },
                "& .MuiTableBody .MuiTableCell-root": {
                  py: "4px !important",
                  paddingTop: "4px !important",
                  paddingBottom: "4px !important",
                },
                "& .table-cell": {
                  paddingTop: "4px !important",
                  paddingBottom: "4px !important",
                },
              }}
            >
              <colgroup>
                {!isTeleSales && <col style={{ width: 52 }} />}
                {visibleColumns.map(({ column }) => (
                  <col
                    key={column.id}
                    style={{
                      width: column.width ? `${column.width}px` : "auto",
                    }}
                  />
                ))}
              </colgroup>
              <TableHead>
                <TableRow className="table-cell-header">
                  {!isTeleSales && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={selectedRows.length > 0 && !allSelected}
                        checked={allSelected}
                        onChange={handleSelectAllRows}
                        size="small"
                        className="checkBox"
                      />
                    </TableCell>
                  )}
                  {visibleColumns.map(({ column, index }) => {
                    const isHovered = hoveredHeader === index;
                    return (
                      <TableCell
                        key={column.id}
                        align={column.numeric ? "right" : "left"}
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.75rem",
                          color: "#212b36",
                          letterSpacing: 0.5,
                          position: "relative",
                          pr: isHovered ? 4.5 : 2,
                          py: 0.6,
                          width: column.width ? `${column.width}px` : "auto",
                          whiteSpace:
                            column.id === "customer" ? "nowrap" : undefined,
                        }}
                        onMouseEnter={() => setHoveredHeader(index)}
                        onMouseLeave={() =>
                          setHoveredHeader((prev) =>
                            prev === index ? null : prev,
                          )
                        }
                      >
                        {column.label}
                        {isHovered && (
                          <IconButton
                            size="small"
                            sx={{
                              position: "absolute",
                              right: 4,
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                            onClick={(event) => {
                              event.stopPropagation();
                              setIsManageColumnsOpen(true);
                            }}
                          >
                            <Iconify
                              icon="mdi:dots-horizontal"
                              width={16}
                              height={16}
                            />
                          </IconButton>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  Array.from({ length: rowsPerPage }).map((_, index) => (
                    <TableRow key={`skeleton-${index}`}>
                      {!isTeleSales && (
                        <TableCell padding="checkbox">
                          <Skeleton
                            variant="rectangular"
                            width={36}
                            height={20}
                          />
                        </TableCell>
                      )}
                      {visibleColumns.map(({ column }) => (
                        <TableCell
                          key={`${column.id}-${index}`}
                          align={column.numeric ? "right" : "left"}
                          sx={{
                            py: 1,
                            fontSize: "0.75rem",
                            width: column.width ? `${column.width}px` : "auto",
                            whiteSpace:
                              column.id === "customer" ? "nowrap" : undefined,
                          }}
                        >
                          <Skeleton variant="text" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : data.length > 0 ? (
                  data.map((row, rowIndex) => (
                    <TableRow
                      key={row.ids || row.reference_no || rowIndex}
                      hover
                      selected={isRowSelected(row)}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.04)",
                        },
                      }}
                    >
                      {!isTeleSales && (
                        <TableCell padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={isRowSelected(row)}
                            onChange={() => handleSelectRow(row)}
                            disabled={row.sale_status === "Hold"}
                            className="checkBox"
                          />
                        </TableCell>
                      )}
                      {visibleColumns.map(({ column }) => (
                        <TableCell
                          key={column.id}
                          align={column.numeric ? "right" : "left"}
                          className="table-cell"
                          sx={{
                            width: column.width ? `${column.width}px` : "auto",
                            whiteSpace:
                              column.id === "customer" ? "nowrap" : undefined,
                          }}
                        >
                          {renderCellContent(column.id, row)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={visibleColumns.length + (isTeleSales ? 0 : 1)}
                      sx={{ py: 4 }}
                    >
                      <Typography
                        align="center"
                      >
                        No records found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            sx={{
              flexShrink: 0,
              minHeight: 40,
              "& .MuiTablePagination-toolbar": {
                minHeight: 40,
                py: 0,
              },
            }}
          >
            <TablePagination
              component="div"
              count={totalRows}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              className="pagination-styles"
            />
          </Box>
        </Paper>
      </Box>
      <Menu
        anchorEl={actionAnchorEl}
        open={Boolean(actionAnchorEl)}
        onClose={handleActionMenuClose}
      >
        {isAcceptedTab ? (
          <MenuItem
            sx={{
              fontWeight: 500,
              fontSize: "0.8rem",
            }}
            onClick={() => {
              if (actionRow) {
                handlePrintInvoice(actionRow.ids);
              }
              handleActionMenuClose();
            }}
          >
            Print Invoice
          </MenuItem>
        ) : (
          <>
        {actionRow?.sale_status !== "Hold" && (
          <MenuItem
            sx={{
              fontWeight: 500,
              fontSize: "0.8rem",
            }}
            onClick={() => {
              if (actionRow) {
                handleRejectClick(actionRow);
              }
            }}
          >
            Reject
          </MenuItem>
        )}
        {actionRow?.sale_status === "New" && (
          <>
            <MenuItem
              sx={{
                fontWeight: 500,
                fontSize: "0.8rem",
              }}
              onClick={() => {
                if (actionRow) {
                  handleHoldClick(actionRow);
                }
              }}
            >
              Hold
            </MenuItem>
            <MenuItem
              sx={{
                fontWeight: 500,
                fontSize: "0.8rem",
              }}
              onClick={() => {
                if (actionRow) {
                  handlePrintInvoice(actionRow.ids);
                }
                handleActionMenuClose();
              }}
            >
              Print Invoice
            </MenuItem>
            {showChangeDeliveryDate && (
              <MenuItem
                sx={{
                  fontWeight: 500,
                  fontSize: "0.8rem",
                }}
                onClick={() => {
                  if (actionRow) {
                    handleChangeDeliveryDateClick(actionRow);
                  }
                }}
              >
                Change Delivery Date
              </MenuItem>
            )}
            {isRHPOrHP && (
              <>
                <MenuItem
                  sx={{
                    fontWeight: 500,
                    fontSize: "0.8rem",
                  }}
                  onClick={() => {
                    if (actionRow) {
                      handlePrintDeliveryNote(actionRow.ids);
                    }
                    handleActionMenuClose();
                  }}
                >
                  Print Delivery Note
                </MenuItem>
                <MenuItem
                  sx={{
                    fontWeight: 500,
                    fontSize: "0.8rem",
                  }}
                  onClick={() => {
                    if (actionRow) {
                      handlePrintDrinkSheet(actionRow.ids);
                    }
                    handleActionMenuClose();
                  }}
                >
                  Print Drink Sheet
                </MenuItem>
              </>
            )}
          </>
        )}
        {actionRow?.sale_status === "Hold" && (
          <>
            <MenuItem
              sx={{
                fontWeight: 500,
                fontSize: "0.8rem",
              }}
              onClick={() => {
                setHoldReasonText(
                  actionRow.hold_reason ||
                    actionRow.reason_note ||
                    actionRow.holdReason ||
                    actionRow.reason ||
                    "-"
                );
                setShowHoldReasonModal(true);
                handleActionMenuClose();
              }}
            >
              Reason
            </MenuItem>
            <MenuItem
              sx={{
                fontWeight: 500,
                fontSize: "0.8rem",
              }}
              onClick={() => {
                if (actionRow) {
                  handleConvertToNewOrder(actionRow.ids);
                }
              }}
            >
              New Order
            </MenuItem>
            <MenuItem
              sx={{
                fontWeight: 500,
                fontSize: "0.8rem",
              }}
              onClick={() => {
                if (actionRow) {
                  handlePrintQuote(actionRow.ids);
                }
                handleActionMenuClose();
              }}
            >
              Print Quote
            </MenuItem>
            {showChangeDeliveryDate && (
              <MenuItem
                sx={{
                  fontWeight: 500,
                  fontSize: "0.8rem",
                }}
                onClick={() => {
                  if (actionRow) {
                    handleChangeDeliveryDateClick(actionRow);
                  }
                }}
              >
                Change Delivery Date
              </MenuItem>
            )}
            {isRHPOrHP && (
              <>
                <MenuItem
                  sx={{
                    fontWeight: 500,
                    fontSize: "0.8rem",
                  }}
                  onClick={() => {
                    if (actionRow) {
                      handlePrintDeliveryNote(actionRow.ids);
                    }
                    handleActionMenuClose();
                  }}
                >
                  Print Delivery Note
                </MenuItem>
                <MenuItem
                  sx={{
                    fontWeight: 500,
                    fontSize: "0.8rem",
                  }}
                  onClick={() => {
                    if (actionRow) {
                      handlePrintDrinkSheet(actionRow.ids);
                    }
                    handleActionMenuClose();
                  }}
                >
                  Print Drink Sheet
                </MenuItem>
              </>
            )}
          </>
        )}
          </>
        )}
      </Menu>
      <Dialog
        open={showHoldReasonModal}
        onClose={() => setShowHoldReasonModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", pb: 1 }}
        >
          Hold Reason
        </DialogTitle>
        <DialogContent>
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: "#212b36",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              pt: 0.5,
            }}
          >
            {holdReasonText || "-"}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button
            onClick={() => setShowHoldReasonModal(false)}
            className="button-variant-contained"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", pb: 1 }}
        >
          Reject Order
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          {rejectData && (
            <Table size="small" sx={{ mb: 2 }}>
              <TableBody
                className="table-cell-border"
              >
                <TableRow>
                  <TableCell width="40%">Order Id</TableCell>
                  <TableCell className="labelCell">
                    {rejectData.reference_no}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Customer (A/C)</TableCell>
                  <TableCell className="labelCell">
                    {rejectData.customer}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Order Amount</TableCell>
                  <TableCell className="labelCell">
                    {rejectData.grand_total}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Previous Dues</TableCell>
                  <TableCell className="labelCell">
                    {rejectData.prev_due}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )}
          <TextField
            className="form-input-border text-field"
            label="Reason Note"
            value={rejectComment}
            onChange={(event) => setRejectComment(event.target.value)}
            multiline
            minRows={3}
            size="small"
            fullWidth
          />
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button
            variant="outlined"
            onClick={() => setShowRejectModal(false)}
            className="button-variant-outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRejectSubmit}
            variant="contained"
            className="button-variant-contained"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showHoldModal}
        onClose={() => setShowHoldModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", pb: 1 }}
        >
          Hold Order
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            py: 1,
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <TextField
            label="Reason Note"
            className="form-input-border text-field"
            value={holdReason}
            onChange={(event) => setHoldReason(event.target.value)}
            multiline
            minRows={3}
            size="small"
            fullWidth
          />
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button
            onClick={() => setShowHoldModal(false)}
            variant="outlined"
            className="button-variant-outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleHoldSubmit}
            variant="contained"
            size="medium"
            className="button-variant-contained"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showAmtDueModal}
        onClose={() => setShowAmtDueModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", pb: 1 }}
        >
          Amount Dues Invoices for {amtDueCustomer}
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          {amtDueLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 6,
              }}
            >
              <CircularProgress />
            </Box>
          ) : amtDueLedgerData.length === 0 ? (
            <Typography
              align="center"
            >
              No Dues Invoice for this customer.
            </Typography>
          ) : (
            <TableContainer
              sx={{
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                scrollbarWidth: "none",
              }}
            >
              <Table size="small">
                <TableHead
                  sx={{
                    "& .MuiTableCell-head": {
                      fontWeight: 600,
                      fontSize: "0.75rem",
                      color: "#212b36",
                      letterSpacing: 0.5,
                    },
                  }}
                >
                  <TableRow sx={{ backgroundColor: "#f5f7fa" }}>
                    <TableCell>#</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Order No</TableCell>
                    <TableCell>Invoice Date</TableCell>
                    <TableCell align="right">Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {amtDueLedgerData.map((item, index) => (
                    <TableRow
                      key={item.id || index}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(145, 158, 171, 0.04)",
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                        {item.order_date
                          ? format(new Date(item.order_date), "dd-MM-yyyy")
                          : ""}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                        <MuiLink
                          href={`${config.BASE_URL}/sales/invoice/${item.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                          sx={{
                            color: "#212b36",
                            textDecoration: "underline",
                            textDecorationColor: "currentColor",
                          }}
                        >
                          {item.reference_no}
                        </MuiLink>
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                        {item.invoice_date
                          ? format(new Date(item.invoice_date), "dd-MM-yyyy")
                          : ""}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontSize: "0.75rem", color: "#212b36" }}
                      >
                        {item.grand_total}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      align="right"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        color: "#212b36",
                      }}
                    >
                      Total
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        color: "#212b36",
                      }}
                    >
                      {amtDueTotal}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button
            onClick={() => setShowAmtDueModal(false)}
            className="button-variant-outlined"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showDeliveryDateModal}
        onClose={() => {
          if (deliveryDateSaving) return;
          setShowDeliveryDateModal(false);
          setDeliveryDateRow(null);
          setDeliveryDateValue("");
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", pb: 1 }}
        >
          Change Delivery Date
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <Table size="small" sx={{ mb: 2 }}>
            <TableBody className="table-cell-border">
              <TableRow>
                <TableCell width="40%">Order Number</TableCell>
                <TableCell className="labelCell">
                  {deliveryDateRow?.reference_no || "-"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Customer Name (Account No)</TableCell>
                <TableCell className="labelCell">
                  {deliveryDateRow?.customer || "-"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Order Date</TableCell>
                <TableCell className="labelCell">
                  {formatDisplayDate(deliveryDateRow?.date)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Delivery Date</TableCell>
                <TableCell className="labelCell">
                  {formatDisplayDate(
                    deliveryDateValue ||
                      deliveryDateRow?.delivery_date ||
                      deliveryDateRow?.deliverydate,
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <TextField
            className="form-input-border text-field"
            label="Change Delivery Date"
            type="date"
            value={deliveryDateValue}
            onChange={(event) => {
              const value = event.target.value;
              if (isSundayDate(value)) {
                toast.error(
                  "Office is closed on Sunday. Please select another delivery date."
                );
                return;
              }
              setDeliveryDateValue(value);
            }}
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button
            variant="outlined"
            disabled={deliveryDateSaving}
            onClick={() => {
              setShowDeliveryDateModal(false);
              setDeliveryDateRow(null);
              setDeliveryDateValue("");
            }}
            className="button-variant-outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={deliveryDateSaving || !deliveryDateValue}
            onClick={handleSaveDeliveryDate}
            className="button-variant-contained"
            startIcon={
              deliveryDateSaving ? <CircularProgress size={16} color="inherit" /> : null
            }
          >
            {deliveryDateSaving ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showConfirmDialog}
        onClose={() => {
          setShowConfirmDialog(false);
          setConfirmDialogData(null);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", pb: 1 }}
        >
          {confirmDialogData?.title || "Confirm"}
        </DialogTitle>
        <DialogContent
          sx={{
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <Typography
            sx={{ fontSize: "0.875rem", color: "#637381", lineHeight: 1.5 }}
          >
            {confirmDialogData?.message || ""}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button
            onClick={() => {
              setShowConfirmDialog(false);
              setConfirmDialogData(null);
            }}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDialogData?.onConfirm}
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              boxShadow: "none",
              "&:hover": { boxShadow: "none" },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <StandaloneManageColumnsModal
        show={isManageColumnsOpen}
        onHide={() => setIsManageColumnsOpen(false)}
        tableName="newRSalesColumns"
        columns={manageColumnsConfig}
        columnVisibility={columnVisibility}
        onColumnVisibilityChange={handleColumnVisibilityChange}
      />
      <FlashMessage
        message={flashMessage?.message}
        type={flashMessage?.type}
        onClose={handleCloseMessage}
      />
    </Box>
  );
};

export default NewRSales;
